import { connect } from 'react-redux';
import DemoToolTips from '../../../features/demoMode/reading/DemoModeHeader/DemoToolTips/DemoToolTips';
import {
    setDemoType,
    setActiveTourStepId,
    cancelToolTip,
    updateLocation,
    exitDemoMode,
    resetTour,
    toolTips,
} from '../../../api/demoMode/reading/demoModeActions';

import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => {
    return {
        activeStep: selectors.getActiveStep(state),
        hasTourStarted: selectors.getHasTourStarted(state),
        isGuidedTourOn: selectors.getIsGuidedTourOn(state),
        allResultsFetched: selectors.isResultDataFetched(state),
        toolTips,
    };
};

const mapDispatchToProps = dispatch => ({
    setDemoType: newDemoType => {
        dispatch(setDemoType(newDemoType));
    },
    setActiveTourStepId: stepId => dispatch(setActiveTourStepId(stepId)),
    cancelToolTip: () => dispatch(cancelToolTip()),
    updateLocation: url => dispatch(updateLocation(url)),
    exitDemoMode: resetTourBool => dispatch(exitDemoMode(resetTourBool)),
    resetTour: () => dispatch(resetTour()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DemoToolTips);
